import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { UserDefModel } from "../models/user-def.model";
import { Observable } from "rxjs";

@Injectable()
export class UserDefService {

    constructor(private apiService: ApiService) {

    }

    setDefault(model: UserDefModel): Observable<any> {
        return this.apiService.post('userdef/setdefault', model);
    }

    getDefault(model: UserDefModel): Observable<any> {
        return this.apiService.post('userdef/getdefault', model);
    }

}